import React from 'react';
import { TicketKey } from 'flow/types/EntityKeys';

import TicketContactSection from 'flow/components/tickets/TicketContactSection';

interface Props {
    ticketKey: TicketKey;
    /** True when rendered inside the docked right panel (darkens the cards). */
    inPanel?: boolean;
}

const ContactTabContent = ({ ticketKey, inPanel = false }: Props) => (
    <div className="pb-8">
        <TicketContactSection ticketKey={ticketKey} inPanel={inPanel} />
    </div>
);

export default React.memo(ContactTabContent);
